import { render, staticRenderFns } from "./community.vue?vue&type=template&id=59ca05f4&scoped=true"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"
import style0 from "./community.vue?vue&type=style&index=0&id=59ca05f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca05f4",
  null
  
)

export default component.exports